export default __webpack_public_path__ + "static/media/Purple-exec-plus-corp.9456c0b9.svg";